export const getDashboardId = () => {
  const webUrl = window.location.pathname
  const webId = webUrl.substring(webUrl.lastIndexOf('/') + 1)
  return webId
}



// WEBPACK FOOTER //
// ./src/helpers/getDashboardId.ts